var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0834 5.50008C10.0834 8.03008 8.03008 10.0834 5.50008 10.0834C2.97008 10.0834 1.4255 7.53508 1.4255 7.53508M1.4255 7.53508H3.49716M1.4255 7.53508V9.82675M0.916748 5.50008C0.916748 2.97008 2.95175 0.916748 5.50008 0.916748C8.55716 0.916748 10.0834 3.46508 10.0834 3.46508M10.0834 3.46508V1.17341M10.0834 3.46508H8.04841",
    stroke: "#BBBBBB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReSend);
export default __webpack_public_path__ + "static/media/reSend.e4e926efb4fce77a217740f86e7f1582.svg";
export { ForwardRef as ReactComponent };